var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebookMessenger(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17633_49813)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 8C14.988 8 8 14.604 8 23.52C8 28.184 9.912 32.216 13.024 35C13.284 35.232 13.444 35.56 13.452 35.912L13.54 38.76C13.5464 38.9696 13.6042 39.1743 13.7083 39.3563C13.8123 39.5383 13.9595 39.6919 14.1369 39.8037C14.3142 39.9155 14.5164 39.982 14.7254 39.9974C14.9345 40.0128 15.1442 39.9766 15.336 39.892L18.512 38.492C18.78 38.372 19.084 38.352 19.368 38.428C20.828 38.828 22.38 39.044 24 39.044C33.012 39.044 40 32.44 40 23.524C40 14.608 33.012 8 24 8Z",
    fill: "url(#paint0_radial_17633_49813)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3896 28.0627L19.0896 20.6067C19.2664 20.326 19.4995 20.085 19.7741 19.8989C20.0488 19.7128 20.359 19.5857 20.6853 19.5256C21.0115 19.4654 21.3467 19.4736 21.6697 19.5495C21.9926 19.6254 22.2963 19.7675 22.5616 19.9667L26.3016 22.7707C26.4685 22.8957 26.6717 22.963 26.8802 22.9622C27.0888 22.9615 27.2915 22.8929 27.4576 22.7667L32.5056 18.9347C33.1776 18.4227 34.0576 19.2307 33.6096 19.9467L28.9056 27.3987C28.7288 27.6794 28.4957 27.9205 28.221 28.1065C27.9464 28.2926 27.6361 28.4198 27.3099 28.4799C26.9836 28.54 26.6484 28.5319 26.3255 28.4559C26.0025 28.38 25.6988 28.238 25.4336 28.0387L21.6936 25.2347C21.5266 25.1097 21.3235 25.0425 21.1149 25.0432C20.9063 25.0439 20.7037 25.1126 20.5376 25.2387L15.4896 29.0707C14.8176 29.5827 13.9376 28.7787 14.3896 28.0627Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_17633_49813",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.36 40) scale(35.2)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0099FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#A033FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FF5280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7061"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17633_49813"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookMessenger);
export default __webpack_public_path__ + "static/media/facebook-messenger.2413daae8974c7b2e555a59885a9eec3.svg";
export { ForwardRef as ReactComponent };